import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import { isAllowedHost } from './utils/hostGuard';

const rootElement = document.getElementById('root');

if (isAllowedHost()) {
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    rootElement,
  );
} else {
  // Unknown host: do not mount the app (no providers, no API calls).
  // Render a neutral, self-contained block screen.
  ReactDOM.render(
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '24px',
        textAlign: 'center',
        fontFamily: 'Lato, Arial, sans-serif',
        color: '#333',
      }}
    >
      <h1 style={{ fontSize: '20px', margin: '0 0 8px' }}>Invalid host</h1>
      <p style={{ fontSize: '14px', margin: 0, maxWidth: '420px' }}>
        This application is not available on this domain.
      </p>
    </div>,
    rootElement,
  );
}
